import clsx from "clsx";
import type * as React from "react";
import type { VariantProps } from "tailwind-variants";
import { tv } from "tailwind-variants";

const typography = tv(
	{
		base: "font-normal ",
		variants: {
			variant: {
				h1: "text-[32px] font-bold",
				h2: "text-[22px] font-bold ",
				h3: "text-md font-bold",
				h4: "text-sm font-bold",
				h5: "text-[12px] font-bold",
				h6: "text-md font-medium",
				h7: "text-sm font-medium",
				h8: "text-xs font-medium",
				h9: "text-xs font-bold",
				bodyXXG: "text-md font-normal",
				bodyXM: "text-sm font-normal",
				bodyLG: "text-xs font-normal",
				bodySM: "text-[10px] font-normal",
			},
			// weight: {
			//   extraBold: 'font-extrabold',
			//   bold: 'font-bold',
			//   semiBold: 'font-semiBold',
			//   medium: 'font-medium',
			//   regular: 'font-normal',
			// },
		},
		// compoundVariants: [
		//   {
		//     variant: "heading1",
		//     weight: ["extraBold", "semiBold", "regular"],
		//     className: "leading-[56xp]  ",
		//   },
		//   {
		//     variant: "heading1",
		//     weight: "bold",
		//     className: " leading-[65xp]",
		//   },
		//   {
		//     variant: "heading4",
		//     weight: "regular",
		//     className: " leading-[50xp]",
		//   },
		//   {
		//     variant: "heading4",
		//     weight: ["extraBold", "semiBold", "bold"],
		//     className: " leading-[34xp] ",
		//   },
		// ],

		// defaultVariants: {
		//   variant: "paragraph2",
		// },
	},
	{
		responsiveVariants: ["xl"],
	},
);

type TypographyVariants = VariantProps<typeof typography>;

type ITypographyProps = Omit<React.ComponentPropsWithoutRef<"span">, "weight"> &
	TypographyVariants & {
		children: React.ReactNode;
	};

export default function Typography({ variant, ...props }: ITypographyProps) {
	return (
		<span {...props} className={clsx(props.className, typography({ variant }))}>
			{props.children}
		</span>
	);
}
